import React from "react";
import cn from "classnames";
import { useIntl } from "react-intl";
import { GooglenIcon } from "./GoogleIcon";
import "./GoogleButton.scss";

interface Props {
  isActive: boolean;
  onClick: () => void;
  onlySyncText?: boolean;
  className?: string;
}

export const GoogleButton = (props: Props) => {
  const { isActive, onClick, className } = props;
  const intl = useIntl();

  return (
    <button
      type="button"
      className={cn("google-connect-btn", className, {
        "google-connect-btn--connected": isActive,
      })}
      onClick={onClick}
    >
      {!isActive ? <GooglenIcon className="google-connect-btn__icon" /> : null}
      <span className="google-connect-btn__label">
        {!isActive
          ? intl.formatMessage({
              id: props.onlySyncText
                ? "app.home.syncUp"
                : "app.home.syncUpGoogle",
            })
          : intl.formatMessage({ id: "app.home.disconnect" })}
      </span>
    </button>
  );
};
